"use strict";
// Generic Helpers
Object.defineProperty(exports, "__esModule", { value: true });
var isEmptyOrNil = function (value) {
    return (value == null || value == "");
};
var structureData = function (rawData) {
    return {
        token: rawData.token,
        owner: rawData.owner,
        provider: rawData.provider,
        standard: rawData.standard,
        timestamp: rawData.timestamp,
        payload: rawData.payload,
    };
};
var structureStandard = function (rawStandard) {
    return {
        token: rawStandard.token,
        minter: rawStandard.minter,
        name: rawStandard.name,
        schema: rawStandard.schema,
    };
};
var structureDataSet = function (data) {
    return data.map(function (rawData) {
        return structureData(rawData);
    });
};
var structureStandardSet = function (standards) {
    return standards.map(function (rawStandard) {
        return structureStandard(rawStandard);
    });
};
var dataUtils = {
    isEmptyOrNil: isEmptyOrNil,
    structureData: structureData,
    structureDataSet: structureDataSet,
    structureStandard: structureStandard,
    structureStandardSet: structureStandardSet
};
exports.default = dataUtils;
